/* eslint-disable jsx-a11y/anchor-is-valid */
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import axios from "axios";
import csc from "country-state-city";
import { useFormik } from "formik";
import Select from "react-select";
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { ModalProgressBar } from "../../../_metronic/_partials/controls";
import { zip } from "lodash";
import {
  getFormattedNumber,
  resolveCountry,
  resolveState,
  getStateList,
} from "../../helpers/Formatter";

var phoneRegExp = /^\([0-9]{3}\) - [0-9]{3} - [0-9]{4}/;
const Schema = Yup.object().shape({
  firstname: Yup.string().required("First name is required"),
  lastname: Yup.string().required("Last name is required"),
  mobile: Yup.string()
  .matches(phoneRegExp, "Please enter a phone number")
  .min(18, "Phone Number must be exactly 10 digits")
  .required("Phone Number is required")
  .test(
    "valid-number",
    "Sorry, only numbers (0-9) are allowed",
    (value, context) => {
      return (
        value &&
        value.split("@").length > 0 &&
        value.split("@")[0].match(/[(0-9)(\-)(\()(\))( ))]*/g)[0] ==
          value.split("@")[0]
      );
    }
  ),
  // Optional string fields are .nullable(): the DB stores NULL for an unset
  // value, and a non-nullable Yup string rejects null with a "must be a string
  // type" error, which silently disabled Save when editing existing records.
  homephone: Yup.string().nullable(),
  address: Yup.string().required("Street is required"),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  country: Yup.string().nullable(),
  zip: Yup.string().required("Zip is required"),
  refferal: Yup.string().nullable(),
  email: Yup.string()
    .email("Wrong email format")
    .required("Email is required"),
  alternate_email: Yup.string().email("Wrong email format").nullable(),
  password: Yup.string().required("Password is required"),
  alt_refferal: Yup.string().nullable(),
});

// Friendly labels for the "why is Save disabled" summary, so a blocking field
// the admin can't see (e.g. a legacy junk Alternate Email) is named explicitly.
const FIELD_LABELS = {
  firstname: "First Name",
  lastname: "Last Name",
  mobile: "Phone",
  homephone: "Alternate Phone",
  address: "Street",
  city: "City",
  state: "State",
  country: "Country",
  zip: "Zip",
  email: "Email Address",
  alternate_email: "Alternate Email",
  password: "Password",
  refferal: "How Did You Hear About Us?",
  alt_refferal: "Referral detail",
};

export const AddParentForm = ({
  history,
  id,
  initialValues,
  parents,
  setParent,
  duplicateCheck,
  saveParent,
  students,
  existingStudents,
  parent,
  isNew,
  primaryParent,
}) => {
  // Fields
  const [loading, setloading] = useState(false);
  const dispatch = useDispatch();
  const [states, setStates] = useState();
  const [countries, setCountries] = useState();
  const [selectedCountry, setSelectedCountry] = useState();
  const [selectedState, setSelectedState] = useState();
  const [studentChosen, setStudentChosen] = useState([]);
  const familyStudents = useSelector((state) => state.family.students);
  const searchId = useSelector((state) => state.family.searchid);
  const [showingStudents, setShowingStudents] = useState([]);
  const [branch, setBranch] = useState();

  const formik = useFormik({
    initialValues,
    validationSchema: Schema,
    enableReinitialize: true,
    onReset: (values, { resetForm }) => {
      resetForm();
    },
  });

  //getbranch
  const branchId = useSelector(
    (state) => state.auth.branches.currentBranch,
    shallowEqual
  );

  // While an existing parent loads, the container first renders this form with
  // the empty default initialValues (id is already set), then swaps in the real
  // record. email is required on every saved parent, so its presence marks the
  // record as actually loaded — gating on it avoids validating the blank
  // placeholder, which briefly flashed the "Save is disabled" alert on edit.
  const recordLoaded = Boolean(id && initialValues && initialValues.email);

  // When editing, validate the loaded record up front so any field that fails
  // the schema (often legacy/junk data in a field that isn't on screen) surfaces
  // in the summary below the Save button instead of silently disabling it.
  useEffect(() => {
    if (recordLoaded) {
      formik.validateForm();
    }
  }, [recordLoaded, initialValues]);

  useEffect(() => {
    if (
      primaryParent &&
      Object.keys(primaryParent).length > 0 &&
      formik.values.parentType === "new"
    ) {
      formik.setFieldValue("address", primaryParent.address);
      formik.setFieldValue("city", primaryParent.city);
      formik.setFieldValue("zip", primaryParent.zip);

      const country = resolveCountry(primaryParent.country);
      if (country) {
        getStates(country.isoCode, primaryParent.state); // This will also set the state value
        formik.setFieldValue("country", country.name);
        setSelectedCountry(country.isoCode);
      }
    } 
  }, [primaryParent, formik.values.parentType, id]);

  useEffect(() => {
    const getBranchCountry = async () => {
      const result = await axios.get(
        "api/branches/details/" + branchId.branch_id
      );
      setBranch(result.data.results[0]);
    };

    getBranchCountry();
  }, [branchId]);

  // Methods
  //get all countries
  useEffect(() => {
    const localcountries = csc.getAllCountries();

    let newList = localcountries.filter((x) => {
      return (
        x.name == "Canada" ||
        x.name == "United States" ||
        x.name == "Jamaica"
      );
    });
    newList.push(
      ...localcountries.filter((x) => {
        return (
          x.name != "Canada" &&
          x.name != "United States" &&
          x.name != "Jamaica"
        );
      })
    );

    setCountries(newList);
    const matchedCountry =
      id && initialValues && initialValues.country
        ? resolveCountry(initialValues.country)
        : null;
    if (matchedCountry) {
      getStates(matchedCountry.isoCode, initialValues.state);
      setSelectedCountry(matchedCountry.isoCode);
    } else if (branch) {
      const country = resolveCountry(branch.country_name);
      if (country) {
        getStates(country.isoCode);
        setSelectedCountry(country.isoCode);
        formik.setFieldValue("country", country.name);
      }
    }
  }, [branch]);

  useEffect(() => {
    // console.log("isNew", isNew);
    if (isNew == "new") {
      formik.setFieldValue("parentType", "new");
    }
  }, [isNew]);

  useEffect(() => {
    if (existingStudents) {
      let show = [];
      show = familyStudents.map((s) => {
        return { value: s.user_id, label: s.name };
      });
      show.push(
        ...existingStudents
          .filter((s2) => {
            return (
              familyStudents.filter((s) => {
                return s2.user_id == s.user_id;
              }).length == 0
            );
          })
          .map((s) => {
            return { value: s.user_id, label: s.studentName };
          })
      );
      setStudentChosen(show);
    } else {
      let show = familyStudents.map((s) => {
        return { value: s.user_id, label: s.name };
      });
      setStudentChosen(show);
    }
  }, [existingStudents]);

  //get all states of country
  const getStates = (country, stateToSet) => {
    const localStates = getStateList(country);
    setStates(localStates);

    if (id && initialValues && initialValues.state) {
      // Editing an existing parent: match the saved state. On no match leave
      // the picker on the placeholder rather than fabricating the first option.
      const dbState = resolveState(country, initialValues.state);
      if (dbState) {
        setSelectedState(dbState.name);
        formik.setFieldValue("state", dbState.name);
      } else {
        setSelectedState("");
      }
    } else if (stateToSet) {
      const foundState = resolveState(country, stateToSet);
      if (foundState) {
        setSelectedState(foundState.name);
        formik.setFieldValue("state", foundState.name);
      } else {
        setSelectedState("");
      }
    } else if (branch) {
      const branchState = resolveState(country, branch.state);
      setSelectedState(branchState ? branchState.name : "");
      formik.setFieldValue("state", branchState ? branchState.name : "");
    } else {
      setSelectedState("");
    }
  };

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const existingParentAutocomplete = () => {
    return (
      <div className="form-group row">
        <label className="col-xl-3 col-lg-3 col-form-label">
          Select a Parent
        </label>
        <div className="col-lg-9 col-xl-6">
          <Autocomplete
            options={parents}
            getOptionLabel={(p) => p.parentName}
            id="parents"
            //value={student}
            onChange={(event, newParent) => {
              if (newParent) {
                setParent(newParent);
              }
            }}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" />
            )}
          />
        </div>
      </div>
    );
  };

  const studentMultiSelect = () => {
    return (
      <div className="form-group row">
        <label className="col-xl-3 col-lg-3 col-form-label">
          Select a Student
        </label>
        <div className="col-lg-9 col-xl-6">
          <Select
            key={""}
            name="students"
            className="react-select"
            options={students.map((s) => {
              return { value: s.user_id, label: s.studentName };
            })}
            onChange={(val) => {
              if (val) {
                setStudentChosen(val);
              }
            }}
            value={studentChosen}
            isMulti
          />
        </div>
        {studentChosen.length < 1 ? (
          <div className="text-default">Please Select At Least One Parent</div>
        ) : null}
      </div>
    );
  };

  const mainForm = () => {
    return (
      // console.log(formik.errors),
      (
        <div>
          {id ? (
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label">Status</label>
              <div className="col-lg-9 col-xl-6">
                <select
                  className="form-control form-control-lg form-control-solid"
                  name="active_id"
                  {...formik.getFieldProps("active_id")}
                >
                  <option value="1">Active</option>
                  <option
                    value="0"
                    disabled={
                      parent?.primary_ind === 1 &&
                      existingStudents?.some((s) => s.active_id === 1)
                    }
                  >
                    In-Active
                  </option>
                </select>
                {parent?.primary_ind === 1 &&
                existingStudents?.some((s) => s.active_id === 1) ? (
                  <div className="text-danger mt-2">
                    Cannot inactivate primary parent with active student.
                  </div>
                ) : null}
              </div>
            </div>
          ) : null}
          
          {/* begin::Form Group */}
          <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label required-field">
              First Name
            </label>
            <div className="col-lg-9 col-xl-6">
              <div>
                <input
                  type="text"
                  className={`form-control form-control-lg form-control-solid ${getInputClasses(
                    "firstname"
                  )}`}
                  name="firstname"
                  {...formik.getFieldProps("firstname")}
                />
                {formik.touched.firstname && formik.errors.firstname ? (
                  <div className="invalid-feedback">
                    {formik.errors.firstname}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          {/* begin::Form Group */}
          <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label required-field">
              Last Name
            </label>

            <div className="col-lg-9 col-xl-6">
              <div>
                <input
                  type="text"
                  className={`form-control form-control-lg form-control-solid ${getInputClasses(
                    "lastname"
                  )}`}
                  name="lastname"
                  {...formik.getFieldProps("lastname")}
                />
                {formik.touched.lastname && formik.errors.lastname ? (
                  <div className="invalid-feedback">
                    {formik.errors.lastname}
                  </div>
                ) : null}
              </div>
            </div>
          </div>

          {/* begin::Form Group */}
          <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label required-field">
              Email Address
            </label>
            <div className="col-lg-9 col-xl-6">
              <div className="input-group input-group-lg input-group-solid">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    <i className="fa fa-at"></i>
                  </span>
                </div>
                <input
                  type="text"
                  placeholder="Email"
                  className={`form-control form-control-lg form-control-solid ${getInputClasses(
                    "email"
                  )}`}
                  name="email"
                  {...formik.getFieldProps("email")}
                />
                {formik.touched.email && formik.errors.email ? (
                  <div className="invalid-feedback">{formik.errors.email}</div>
                ) : null}
              </div>
            </div>
          </div>

          {/* begin::Form Group */}
          <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label required-field">
              Phone
            </label>

            <div className="col-lg-9 col-xl-6">
              <div>
                <input
                  type="text"
                  className={`form-control form-control-lg form-control-solid ${getInputClasses(
                    "mobile"
                  )}`}
                  name="mobile"
                  {...formik.getFieldProps("mobile")}
                  onChange={(e) => {
                    let phoneNumber = getFormattedNumber(e.target.value);
                    formik.setFieldValue("mobile", phoneNumber);
                  }}
                />
                {formik.touched.mobile && formik.errors.mobile ? (
                  <div className="invalid-feedback">{formik.errors.mobile}</div>
                ) : null}
              </div>
            </div>
          </div>
          {/* begin::Form Group */}
          <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label">Gender</label>
            <div className="col-lg-9 col-xl-6">
              <select
                className="form-control form-control-lg form-control-solid"
                name="gender"
                {...formik.getFieldProps("gender")}
              >
                <option value="">Select Gender...</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>
          {/* begin::Form Group */}
          <div className="separator separator-dashed my-5"></div>
          {/* begin::Form Group */}
          <div className="row">
            <label className="col-xl-3"></label>
            <div className="col-lg-9 col-xl-6">
              <h5 className="font-weight-bold mb-6">Address:</h5>
            </div>
          </div>
          {/* begin::Form Group */}
          <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label required-field">
              Street
            </label>
            <div className="col-lg-9 col-xl-6">
              <input
                type="text"
                placeholder="Street"
                className={`form-control form-control-lg form-control-solid ${getInputClasses(
                  "address"
                )}`}
                name="address"
                {...formik.getFieldProps("address")}
              />
              {formik.touched.address && formik.errors.address ? (
                <div className="invalid-feedback">{formik.errors.address}</div>
              ) : null}
            </div>
          </div>
          {/* begin::Form Group */}
          <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label required-field">
              City
            </label>
            <div className="col-lg-9 col-xl-6">
              <input
                type="text"
                placeholder="City"
                className={`form-control form-control-lg form-control-solid ${getInputClasses(
                  "city"
                )}`}
                name="city"
                {...formik.getFieldProps("city")}
              />
              {formik.touched.city && formik.errors.city ? (
                <div className="invalid-feedback">{formik.errors.city}</div>
              ) : null}
            </div>
          </div>

          <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label required-field">
              Country
            </label>
            <div className="col-lg-9 col-xl-6">
              <select
                name="country"
                label="Country"
                value={selectedCountry}
                onChange={(e) => {
                  const picked = resolveCountry(e.target.value);
                  formik.setFieldValue("country", picked ? picked.name : "");
                  setSelectedCountry(e.target.value);
                  getStates(e.target.value, null);
                }}
                className="form-control form-control-lg form-control-solid"
              >
                {countries &&
                  countries.map((a) => (
                    <option key={a.isoCode} value={a.isoCode}>
                      {a.name}
                    </option>
                  ))}
              </select>
              {formik.touched.country && formik.errors.country ? (
                <div className="invalid-feedback">{formik.errors.country}</div>
              ) : null}
            </div>
          </div>
          {/* begin::Form Group */}
          <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label required-field">
              State
            </label>
            <div className="col-lg-9 col-xl-6">
              <select
                name="state"
                label="State"
                value={selectedState}
                className="form-control form-control-lg form-control-solid"
                onChange={(e) => {
                  const picked = resolveState(selectedCountry, e.target.value);
                  setSelectedState(picked ? picked.name : "");
                  formik.setFieldValue("state", picked ? picked.name : "");
                }}
              >
                <option value="">Select State...</option>
                {states &&
                  states.map((a) => (
                    <option key={a.isoCode} value={a.name}>
                      {a.name}
                    </option>
                  ))}
              </select>
              {formik.touched.state && formik.errors.state ? (
                <div className="invalid-feedback">{formik.errors.state}</div>
              ) : null}
            </div>
          </div>
          {/* begin::Form Group */}
          <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label required-field">
              Zip
            </label>
            <div className="col-lg-9 col-xl-6">
              <input
                type="text"
                placeholder="zip"
                className={`form-control form-control-lg form-control-solid ${getInputClasses(
                  "zip"
                )}`}
                name="zip"
                {...formik.getFieldProps("zip")}
              />
              {formik.touched.zip && formik.errors.zip ? (
                <div className="invalid-feedback">{formik.errors.zip}</div>
              ) : null}
            </div>
          </div>

          {/* begin::Form Group */}
          <div className="separator separator-dashed my-5"></div>
          {/* begin::Form Group */}
          <div className="row">
            <label className="col-xl-3"></label>
            <div className="col-lg-9 col-xl-6">
              <h5 className="font-weight-bold mb-6">Optional:</h5>
            </div>
          </div>

          <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label">
              Alternate Phone
            </label>
            <div className="col-lg-9 col-xl-6">
              <input
                type="text"
                placeholder="Alternate Phone"
                className={`form-control form-control-lg form-control-solid ${getInputClasses(
                  "homephone"
                )}`}
                name="homephone"
                {...formik.getFieldProps("homephone")}
                onChange={(e) => {
                  let phoneNumber = getFormattedNumber(e.target.value);
                  formik.setFieldValue("homephone", phoneNumber);
                }}
              />
              {formik.touched.homephone && formik.errors.homephone ? (
                <div className="invalid-feedback">
                  {formik.errors.homephone}
                </div>
              ) : null}
            </div>
          </div>
          {/* begin::Form Group */}
          <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label">
              Alternate Email
            </label>
            <div className="col-lg-9 col-xl-6">
              <div className="input-group input-group-lg input-group-solid">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    <i className="fa fa-at"></i>
                  </span>
                </div>
                <input
                  type="text"
                  placeholder="Alternate Email"
                  className={`form-control form-control-lg form-control-solid ${getInputClasses(
                    "alternate_email"
                  )}`}
                  name="alternate_email"
                  {...formik.getFieldProps("alternate_email")}
                />
                {formik.touched.alternate_email &&
                formik.errors.alternate_email ? (
                  <div className="invalid-feedback">
                    {formik.errors.alternate_email}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          {/* begin::Form Group */}
          <div className="form-group row">
            <label className="col-xl-3 col-lg-3 col-form-label">
              How Did You Hear About Us?
            </label>
            <div className="col-lg-9 col-xl-6">
              <select
                className="form-control form-control-lg form-control-solid"
                name="refferal"
                {...formik.getFieldProps("refferal")}
              >
                {[
                  "Google Search",
                  "AI Assistant (ChatGPT, Gemini, etc.)",
                  "Friends and Family",
                  "Social Media",
                  "Drive Thru",
                  "Company Email",
                  "Returning Student",
                  "Other",
                ].map((i) => (
                  <option key={i} value={i}>
                    {i}
                  </option>
                ))}
              </select>
              {formik.touched.refferal && formik.errors.refferal ? (
                <div className="invalid-feedback">{formik.errors.refferal}</div>
              ) : null}
            </div>
          </div>
          {formik.values.refferal == "Other" ? (
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label"></label>
              <div className="col-lg-9 col-xl-6">
                <input
                  type="text"
                  placeholder="How Did You Hear About Us?"
                  className={`form-control form-control-lg form-control-solid ${getInputClasses(
                    "alt_refferal"
                  )}`}
                  name="alt_refferal"
                  {...formik.getFieldProps("alt_refferal")}
                />
                {formik.touched.alt_refferal && formik.errors.alt_refferal ? (
                  <div className="invalid-feedback">
                    {formik.errors.alt_refferal}
                  </div>
                ) : null}
              </div>
            </div>
          ) : null}
        </div>
      )
    );
  };

  return (
    <form className="card card-custom">
      {loading && <ModalProgressBar />}

      {/* begin::Header */}
      <div className="card-header py-3">
        <div className="card-title align-items-start flex-column">
          <h3 className="card-label font-weight-bolder text-dark">Parent</h3>
          <span className="text-muted font-weight-bold font-size-sm mt-1">
            {id ? "Edit" : "Add"} parent information
          </span>
        </div>
        <div className="card-toolbar">
          <button
            type="button"
            className="btn btn-success mr-2"
            disabled={
              !formik.touched || formik.values.parentType == ""
                ? true
                : formik.values && formik.values.parentType == "existing"
                ? id
                  ? !parent || !formik.isValid
                  : !parent && !formik.isValid
                : formik.isSubmitting || !formik.isValid
            }
            onClick={() => {
              const foundCountry = countries?.find((c) => c.isoCode == selectedCountry);
              duplicateCheck(
                {
                  ...formik.values,
                  country: foundCountry?.name || formik.values.country,
                },
                formik.setStatus,
                formik.setSubmitting,
                studentChosen
              );
            }}
          >
            {id ? "Save" : "Add"}
            {formik.isSubmitting}
          </button>
         
          <Link
            to={searchId ? "/family-profile/" + searchId + "/parents" : "/dashboard"}
            className="btn btn-secondary"
          >
            Cancel
          </Link>
        </div>
      </div>
      {/* end::Header */}
      {/* Explain why Save is disabled instead of leaving a silently greyed-out button */}
      {recordLoaded && Object.keys(formik.errors).length > 0 ? (
        <div className="alert alert-warning mb-0 mx-4 mt-4" role="alert">
          <strong>Save is disabled — please fix:</strong>
          <ul className="mb-0 mt-1">
            {Object.entries(formik.errors).map(([field, message]) => (
              <li key={field}>
                {FIELD_LABELS[field] || field}: {message}
              </li>
            ))}
          </ul>
        </div>
      ) : null}
      {/* begin::Form */}
      <div className="form">
        <div className="card-body">
          {/* begin::Heading */}
          {id ? null : (
            <div className="form-group row">
              <label className="col-xl-3 col-lg-3 col-form-label">
                Add an...
              </label>

              <div className="col-lg-9 col-xl-6">
                <select
                  name="parentType"
                  className={`form-control form-control-lg form-control-solid ${getInputClasses(
                    "parentType"
                  )}`}
                  {...formik.getFieldProps("parentType")}
                >
                  {isNew != "new" ? <option value="">Choose...</option> : ""}
                  {isNew != "new" ? (
                    <option value="existing">Existing Parent</option>
                  ) : (
                    ""
                  )}

                  <option value="new">New Parent</option>
                </select>
                {formik.touched.parentType && formik.errors.parentType ? (
                  <div className="invalid-feedback">
                    {formik.errors.parentType}
                  </div>
                ) : null}
              </div>
            </div>
          )}
          {/* Show the entire form if editing a student or adding a new student, but not if adding an existing student */}
          {(!id && formik.values.parentType == "new") || id ? mainForm() : null}
          <>
            {/* Show an autocomplete if adding an existing student */}
            {formik.values.parentType == "existing" && !id
              ? existingParentAutocomplete()
              : null}
            {students &&
            (formik.values.parentType == "new" ||
              formik.values.parentType == "existing")
              ? studentMultiSelect()
              : null}
          </>
        </div>
      </div>
      {/* end::Form */}
    </form>
  );
};
export default AddParentForm;
